'use strict';

var implementation = require('./implementation');

var assignHasPendingExceptions = function () {
	if (!Object.assign || !Object.preventExtensions) {
		return false;
	}
	// Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	// which is 72% slower than our shim, and Firefox 40's native implementation.
	var thrower = Object.preventExtensions({ 1: 2 });
	try {
		Object.assign(thrower, 'xy');
	} catch (e) {
		return thrower[1] === 'y';
	}
};

module.exports = function getPolyfill() {
	return !Object.assign || assignHasPendingExceptions() ? implementation : Object.assign;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/alt-container/~/object.assign/polyfill.js
 ** module id = 169
 ** module chunks = 1
 **/